import type { Copy } from "../types";

export const ro: Copy = {
    seo: {
      title: "Calculator vârstă vehicul | verificare după an și lună",
      description:
        "Verifică vârsta exactă a unui vehicul după anul și luna opțională de fabricație. Vezi ani, luni, zile, total zile și momente-cheie într-un singur instrument curat.",
      keywords: [
        "calculator vârstă vehicul",
        "vârsta mașinii",
        "vârsta vehiculului după an",
        "an fabricație mașină",
        "lună fabricație vehicul",
        "cât de veche este mașina mea",
        "verificare vârstă vehicul",
        "calculator vârstă RC",
        "calculator dată vehicul",
        "calculator vârstă mașină după lună",
        "alternativă mParivahan",
        "alternativă Parivahan",
        "calculator vârstă vehicul RTO",
        "verificare vârstă înmatriculare mașină",
        "vârsta înmatriculării vehiculului",
      ],
      faq: [
        {
          question: "Ce face acest calculator?",
          answer:
            "Calculează vârsta exactă a unui vehicul din anul de fabricație selectat și luna opțională, apoi afișează anii, lunile, zilele și informațiile despre momente-cheie.",
        },
        {
          question: "De ce există o lună opțională?",
          answer:
            "Adăugarea lunii face calculul mai precis. Dacă sari peste lună, aplicația folosește ianuarie din anul selectat.",
        },
        {
          question: "Pot alege un an sau o lună viitoare?",
          answer:
            "Nu. Anii viitori sunt blocați, iar lunile viitoare sunt dezactivate când anul selectat este anul curent.",
        },
      ],
    },
    headerTagline: "Utilitar pentru vehicule",
    headerTitle: "Calculator vârstă mașină",
    reset: "Resetare",
    switchToLight: "Treci la modul luminos",
    switchToDark: "Treci la modul întunecat",
    languageLabel: "Limbă",
    languageEnglish: "Engleză",
    languageHindi: "Hindi",
    heroEyebrow: "Vârsta mașinii, clar",
    heroTitle: "Un instrument curat pentru vârsta vehiculului.",
    heroDescription: "Alege anul fabricației. Adaugă luna doar dacă vrei un rezultat mai precis.",
    yearSelectLabel: "An fabricație",
    monthSelectLabel: "Lună fabricație",
    includeMonthLabel: "Include luna specifică pentru mai multă precizie",
    includeMonthNote: "Dacă nu incluzi o lună, se folosește ianuarie pentru calcul.",
    yearOnlyBadge: "Doar an",
    yearMonthBadge: "An + lună",
    yearPlaceholder: "Alege anul",
    monthPlaceholder: "Alege luna",
    inputTitle: "An fabricație",
    inputLabel: "An fabricație",
    blockedDateNote: "Anii viitori sunt blocați.",
    result: "Rezultat",
    vehicleAgeLead: "Vehiculul tău este",
    asOfToday: "La ziua de azi",
    years: "Ani",
    months: "Luni",
    days: "Zile",
    totalDays: (count) => `${count.toLocaleString("en-IN")} zile în total`,
    ageLabels: { almostNew: "Aproape nou", modern: "Modern", mature: "Matur", classic: "Clasic" },
    estimatedValue: {
      high: "Potențial ridicat de revânzare",
      healthy: "Păstrare sănătoasă a valorii",
      moderate: "Depreciere moderată",
      collector: "Poate crește interesul colecționarilor",
    },
    maintenanceTitle: "Întreținere",
    maintenance: {
      routine: "Service obișnuit și îngrijire OEM",
      watch: "Urmărește frânele, lichidele și anvelopele",
      plan: "Planifică piesele de uzură și inspecțiile",
      specialized: "Întreținerea specializată devine importantă",
    },
    registrationTitle: "Înmatriculare",
    registration: {
      collector: "Poate beneficia de regim de colecție în unele regiuni",
      classic: "Poate exista în unele regiuni înmatriculare clasică",
      standard: "Așteaptă reînnoiri standard și verificări regionale",
      regular: "De obicei se aplică înmatricularea obișnuită",
    },
    upcomingMilestoneTitle: "Următorul prag",
    milestoneTimelineTitle: "Cronologia pragurilor",
    milestoneRemaining: ({ label, days }) => `${label} în ${days.toLocaleString("ro-RO")} zile`,
    reached: "Atins",
    upcoming: "În curs",
    allMilestonesReachedTitle: "Toate pragurile listate au fost atinse",
    allMilestonesReachedBody: "Acest vehicul a trecut deja de intervalul de praguri afișat în aplicație.",
    copySummary: "Copiază rezumatul",
    shareResult: "Distribuie rezultatul",
    resetMessage: "Calculator resetat",
    summaryCopied: "Rezumat copiat în clipboard",
    clipboardFailed: "Accesul la clipboard a eșuat",
    emptyTitle: "Alege anul fabricației pentru a vedea detaliile complete",
    emptyDescription:
      "Vei vedea vârsta exactă, totalul zilelor, notele de întreținere, statutul clasic și momentul pragurilor după selectarea anului.",
    shareTitle: "Calculator vârstă vehicul",
    summary: ({ label, years, months, days, asOf }) =>
      `Vehiculul meu are data fabricației ${label}, iar la data de ${asOf} are ${years} ani, ${months} luni și ${days} zile.`,
    milestones: {
      1: { label: "Primul an", note: "Util pentru garanție și planificarea service-ului." },
      3: { label: "Trei ani", note: "Punct comun pentru revânzare și schimbări de valoare." },
      5: { label: "Cinci ani", note: "Moment bun pentru un buget de întreținere mai amplu." },
      10: { label: "Zece ani", note: "Componentele mai vechi merită atenție suplimentară." },
      15: { label: "Cincisprezece ani", note: "În multe regiuni începe aici tratamentul clasic." },
      25: { label: "Douăzeci și cinci de ani", note: "Poate interesa colecționarii și piețele de import." },
    },
  };
